import { render, staticRenderFns } from "./HailingFailPopup.vue?vue&type=template&id=6228f9ba&scoped=true&lang=pug"
import script from "./HailingFailPopup.vue?vue&type=script&lang=js"
export * from "./HailingFailPopup.vue?vue&type=script&lang=js"
import style0 from "./HailingFailPopup.vue?vue&type=style&index=0&id=6228f9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228f9ba",
  null
  
)

export default component.exports